import { Controller } from "@hotwired/stimulus"

// Shows the pharmacy field only when the selected role is pharmacist.
export default class extends Controller {
  static targets = ["role", "pharmacy"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasRoleTarget || !this.hasPharmacyTarget) return

    this.pharmacyTarget.hidden = this.roleTarget.value !== "pharmacist"
  }
}
